<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <Header />
    <div class="container mx-auto max-w-[1200px] w-full  px-4 md:px-6">
    <div class="flex justify-center mt-10">
      <div
        style="box-shadow: 0px 2px 20px 0px #105c8e26"
        class="bg-white p-5 rounded-2xl w-full"
      >
        <h3 class="text-lg font-semibold text-blues mb-2">
          Single Upload Form
        </h3>

        <form @submit.prevent="bulkSubmit" class="space-y-4" ref="addRefs">
          <div>
            <label
              for="title"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Title <span class="text-red-400">*</span></label
            >
            <input
              id="title"
              type="text"
              placeholder="Enter Title"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div>
            <label
              for="uploadfile"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Upload File <span class="text-red-400">*</span></label
            >
            <input
              id="uploadfile"
              type="file"
              class="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>

          <div class="flex justify-end pb-4 mt-3">
            <button
              type="submit"
              :disabled="disable_submit || submitted.length > 0"
              :class="[
                'rounded-lg text-sm px-4 py-2',
                disable_submit || submitted.length > 0
                  ? 'bg-gray-200 text-black cursor-not-allowed'
                  : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white',
              ]"
            >
              Submit
            </button>
            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain mt-2"
            />
          </div>
        </form>
      </div>
    </div>
    <div class="mt-5 ">
      <h2 class="text-lg font-semibold mb-4">Submitted Data</h2>
      <div
        v-if="submitted.length > 0"
        class="overflow-x-auto  bg-white rounded-2xl shadow-sm border border-slate-200"
      >
        <table class="min-w-full divide-y divide-gray-200 border rounded-md">
          <thead class="bg-gray-100 text-blues whitespace-nowrap">
            <tr>
              <th class="px-4 py-2 text-left text-sm border-b border-r font-semibold ">
                S.NO
              </th>
              <th class="px-4 py-2 text-left text-sm border-b border-r font-semibold ">
                Email
              </th>
              <th class="px-4 py-2 text-left text-sm border-b border-r font-semibold ">
                Updated at
              </th>
              <th class="px-4 py-2 text-left text-sm border-b border-r font-semibold ">
                Title
              </th>
              <th class="px-4 py-2 text-left text-sm border-b border-r font-semibold ">
                Link
              </th>
              <th class="px-4 py-2 text-left text-sm border-b border-r font-semibold ">
                Edit
              </th>
              <th class="px-4 py-2 text-left text-sm border-b border-r font-semibold ">
                Delete
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 bg-white">
            <tr v-for="(item, index) in submitted" :key="index" class=" whitespace-nowrap">
              <td class="px-4 py-2 text-sm border-b border-r">{{ index + 1 }}</td>
              <td class="px-4 py-2 text-sm border-b border-r">{{ item.user_email }}</td>
              <td class="px-4 py-2 text-sm border-b border-r">
                {{ formatDate(item.updated_at) }}
              </td>
              <td class="px-4 py-2 text-sm border-b border-r">{{ item.title }}</td>
              <td class="px-4 py-2 text-sm border-b border-r">
                <a
                  @click.stop
                  :href="item.pdf"
                  target="_blank"
                  class="flex items-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-700 border border-blue-200 rounded-md hover:bg-blue-100 transition-all text-xs font-semibold shadow-sm w-20"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                  View
                </a>
              </td>

              <td class="px-4 py-2 text-sm cursor-pointer border-b border-r">
                <button @click.stop="startEditing(item)">
                  <img
                    src="@/assets/new/medit.png"
                    class="w-6 h-6 bg-blue-50 hover:bg-blue-100 border border-blue-200 p-1 rounded-md"
                  />
                </button>
              </td>
              <td class="px-4 py-2 text-sm cursor-pointer">
                <button
                  @click="
                    titlepass = item.title;
                    popupwindow = true;
                    idpass = item.id;
                  "
                >
                  <img
                    src="@/assets/new/dele.png"
                    class="w-6 h-6 bg-red-50 border hover:bg-red-100 border-red-200 p-1 rounded-md"
                  />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>No Data Found</div>
    </div>
    <!-- delect popup -->
    <div
      v-if="popupwindow"
      class="fixed flex bg-black bg-opacity-70 justify-center items-center inset-0 z-50 outline-none overflow-x-hidden overflow-y-auto"
      style="z-index: 5000"
    >
      <div class="w-[90%] lg:w-[35%] rounded-md m-4">
        <div
          class="relative flex flex-col clear-both justify-center rounded-t-lg w-full pt-12 p-4 md:p-10 bg-white gap-3"
        >
          <img
            @click="popupwindow = false"
            class="absolute right-2 top-2 cursor-pointer w-5 h-5 object-contain"
            src="@/assets/newd/close.png"
          />
          <p class="text-center font-base text-xl text-gray-600">
            Are you sure want to delete ?
          </p>
          <h1 class="text-center font-bold text-xl text-blues">
            {{ titlepass }}
          </h1>
        </div>
        <div
          class="body-popup flex flex-col rounded-b-lg py-3 md:py-6 px-3 md:px-6 bg-gray-200"
        >
          <div class="flex gap-4 justify-between w-full md:w-3/4 mx-auto">
             <button
              @click="popupwindow = false"
              class="bg-white hover:bg-gray-300 text-gray-700 cursor-pointer text-sm font-semibold rounded-lg overflow-hidden px-4 py-2"
            >
              Cancel
            </button>
            <div class="flex items-center gap-3">
              <button
                type="submit"
                @click="deleteAssign"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-white text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-blue-600 cursor-pointer text-white'
                "
                class="text-sm border font-semibold rounded-lg overflow-hidden px-4 py-2"
              >
                Yes
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
           
          </div>
        </div>
      </div>
    </div>
    <!-- Edit popup -->
    <div
      v-if="this.isEditing"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
    >
      <div
        class="lg:w-[40%] bg-white rounded-xl p-7 overflow-y-auto max-h-[600px]"
      >
        <div class="flex items-center justify-center">
          <h3 class="text-lg font-bold text-blues text-center">
            Edit Single Upload
          </h3>
        </div>

        <div class="w-full flex flex-col relative border-gray-100 rounded-2xl">
          <div class="w-full">
            <form
              ref="createTeamRef"
              @submit.prevent="editAssign"
              class="flex flex-col gap-2 text-xs md:text-sm h-full"
            >
              <div class="w-full flex flex-col gap-2">
                <label for="title" class="text-left">Title</label>
                <input
                  id="title"
                  type="text"
                  v-model="selectedItem.title"
                  class="border border-gray-100 rounded text-xs md:text-sm py-2 px-2"
                />
              </div>

              <div class="flex flex-col gap-3 w-full">
                <label for="assign_file" class="text-left">File</label>

                <input
                  id="assign_file"
                  type="file"
                  @change="handleFileUpload"
                  class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm"
                />

                <div
                  v-if="!thumbnailFile && selectedItem.pdf"
                  class="flex items-center gap-3"
                >
                  <a
                    :href="selectedItem.file"
                    target="_blank"
                    class="text-sm text-blue-600 underline"
                  >
                    {{ selectedItem.pdf.split("/").pop() }}
                  </a>
                  <button
                    @click="removeItem"
                    class="text-red-600 text-xs font-semibold"
                  >
                    Remove
                  </button>
                </div>

                <div v-if="thumbnailFile" class="flex items-center gap-3">
                  <p class="text-sm">{{ thumbnailFile.name }}</p>
                  <button
                    @click="thumbnailFile = null"
                    class="text-red-600 text-xs font-semibold"
                  >
                    Cancel
                  </button>
                </div>
              </div>

              <div class="flex justify-center pb-4 mt-3 gap-10">
                <button
                  @click="this.isEditing = false"
                  class="border text-gray-500 border-[#0085db] hover:border-[#18469d] hover:bg-[#18469d] cursor-pointer hover:text-white rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                >
                  Close
                </button>
                <div class="flex items-center gap-3">
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-gray-200 text-black cursor-not-allowed'
                        : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                    "
                    class="rounded-lg text-sm px-6 py-2"
                  >
                    Submit
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Admin/Header.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedItem: {},
      thumbnailFile: null,
      isEditing: false,
      popupwindow: false,
      submitted: [],
      disable_submit: false,
      messages: {
        text: "",
        type: null,
      },
    };
  },

  components: {
    Header,
    FlashMessage,
  },
  mounted() {
    this.getSubmittedData();
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    formatDate(dateString) {
      const d = new Date(dateString);

      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();

      const hh = String(d.getHours()).padStart(2, "0");
      const mi = String(d.getMinutes()).padStart(2, "0");

      return `${dd}-${mm}-${yyyy} ${hh}:${mi}`;
    },
    removeItem() {
      this.selectedItem.pdf = null;
    },
    handleFileUpload(e) {
      this.thumbnailFile = e.target.files[0];
    },

    startEditing(item) {
      this.selectedItem = { ...item };
      this.isEditing = true;
      this.thumbnailFile = null;
      this.editassignId = item.id;
    },

    async editAssign(e) {
      this.disable_submit = true;
      let updatedEditInfo = new FormData();
      updatedEditInfo.append("title", this.selectedItem.title);

      if (this.thumbnailFile) {
        updatedEditInfo.append("pdf", this.thumbnailFile);
      }

      if (!this.thumbnailFile && !this.selectedItem.file) {
        updatedEditInfo.append("pdf", "");
      }

      await axios
        .put(
          `${process.env.VUE_APP_API}/pdf-upload-update-delete/${this.editassignId}/?Key=${this.userInfo.token_key}`,
          updatedEditInfo
        )
        .then((response) => {
          this.messages = {
            text: response.data.message || "Updated successfully",
            type: "success",
          };
        })
        .catch(() => {
          this.messages = {
            text: "Update failed",
            type: "error",
          };
        })
        .finally(() => {
          this.disable_submit = false;
          setTimeout(() => {
            this.isEditing = false;
            this.getSubmittedData();
            this.messages.text = "";
          }, 1500);
        });
    },

    async deleteAssign() {
      this.disable_submit = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/pdf-upload-update-delete/${this.idpass}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.popupwindow = false;
        this.getSubmittedData();
      }, 2500);
    },
    getSubmittedData() {
      axios
        .get(
          `${process.env.VUE_APP_API}/pdf-upload-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.submitted = res.data.data.data;
        });
    },
    bulkSubmit(e) {
      this.disable_submit = true;
      let formData = new FormData();
      formData.append("title", e.target.title.value);
      formData.append("pdf", e.target.uploadfile.files[0]);

      axios
        .post(
          `${process.env.VUE_APP_API}/pdf-upload/?Key=${this.userInfo.token_key}`,
          formData
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            this.$refs.addRefs.reset();
            this.getSubmittedData();
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
  },
};
</script>

<style></style>
